export default __webpack_public_path__ + "static/media/about2.4fa83368.jpeg";